'use client'

import { useActionState, useTransition } from 'react'
import { addCustomerAddress } from '@onclicks/sharedmedusa/medusaData/customer'
import { Input } from '../ui/input'
import SimpleCountrySelect from './SimpleCountrySelect'
import { Button } from '../ui/Button'
import { bagelFatOne } from '@/utilities/fontImport'
import { cn } from '@/utilities/ui'

const AddressFormCustomer = ({
  type,
  title,
  address,
}: {
  type: 'shipping' | 'billing'
  title: string
  address?: any
}) => {
  const [state, formAction] = useActionState(addCustomerAddress, {
    success: false,
    error: null,
  })

  const [isPending, startTransition] = useTransition()

  // Soumission manuelle : passer la fonction à `<form action>` déclenche un reset automatique
  // du formulaire (React 19) qui vide le select pays.
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    startTransition(() => formAction(formData))
  }

  return (
    <div className="rounded-[2.5rem] border border-white bg-white shadow-xl shadow-light-pink/40 p-8 lg:p-10">
      <h3 className={cn('text-xl font-bold text-primary mb-6', bagelFatOne.className)}>{title}</h3>

      {state?.error && (
        <div className="mb-5 flex items-center gap-2.5 rounded-2xl bg-light-red/15 px-4.5 py-3">
          <span className="text-sm font-bold text-light-red">{state.error}</span>
        </div>
      )}
      {state?.success && (
        <div className="mb-5 flex items-center gap-2.5 rounded-2xl bg-light-pink px-4.5 py-3">
          <span className="text-sm font-bold text-primary">Adresse enregistrée avec succès !</span>
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <input type="hidden" name="address_id" value={address?.id || ''} />
        <input
          type="hidden"
          name="is_default_shipping"
          value={type === 'shipping' ? 'on' : 'off'}
        />
        <input type="hidden" name="is_default_billing" value={type === 'billing' ? 'on' : 'off'} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <SimpleCountrySelect
            name="country_code"
            defaultValue={address?.country_code?.toLowerCase() || ''}
            required
            className="md:col-span-2"
          />
          <Input
            label="Prénom"
            name="first_name"
            defaultValue={address?.first_name || ''}
            required
          />
          <Input label="Nom" name="last_name" defaultValue={address?.last_name || ''} required />
          <Input
            label="Entreprise"
            name="company"
            defaultValue={address?.company || ''}
            className="md:col-span-2"
          />
          <Input
            label="Adresse"
            name="address_1"
            required
            defaultValue={address?.address_1 || ''}
            className="md:col-span-2"
          />
          <Input label="Ville" name="city" defaultValue={address?.city || ''} required />
          <Input
            label="Code Postal"
            name="postal_code"
            defaultValue={address?.postal_code || ''}
            required
          />
          <Input
            label="Province/État"
            name="province"
            defaultValue={address?.province || ''}
            required
          />

          <Input label="Téléphone" name="phone" defaultValue={address?.phone || ''} required />
        </div>
        <Button
          type="submit"
          className="mt-6"
          variant="gradientOrangeToPink"
          disabled={isPending}
        >
          Enregistrer l&apos;adresse
        </Button>
      </form>
    </div>
  )
}

export default AddressFormCustomer
